/*
 * @Descripttion: 指标加减分设置表 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-04-22
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-05-02 23:31:51
 */

import http from '@/utils/kq/http';

const veStuIdxScoreConfigApi = {
  //添加接口
  add(data) {
    return http.post(http.service.stu + 'veStuIdxScoreConfig/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.stu + 'veStuIdxScoreConfig/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.stu + 'veStuIdxScoreConfig/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.stu + 'veStuIdxScoreConfig/page', pageData);
  },
  //分页查询接口
  all(pageData) {
    return http.post(http.service.stu + 'veStuIdxScoreConfig/all', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.stu + 'veStuIdxScoreConfig/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.stu + 'veStuIdxScoreConfig/updateStatus', data);
  }
};
export default veStuIdxScoreConfigApi;
